<!--
    校区管理-老师管理
    功能：展示老师列表数据、是否禁用账号、信息编辑、上课统计
    说明：版本3.0修改了课程权限
    组件:AppList、AppSearch
-->
<template>
  <div class="staff">
    <!--
      excelLabel="批量导入"
      downloadLabel="导出模板"-->
    <AppList
      ref="list"
      :list.sync="list"
      :create-label="$permissions('school_teacher_list_add') ? '新增老师' : ''"
      :api-type="apiUrl"
      title=""
      api="/api/staff"
      @create="toCreate"
      @excelPage="excelExport"
      @downloadPage="downloadTemplate">
      <AppSearch
        slot="search"
        :order="{ type: 'id', name: 'desc'}"
        :search-arr="searchArr"/>
      <template slot-scope="props">
        <el-table :data="props.listData">
          <el-table-column
            width="80px"
            label="头像">
            <template slot-scope="scope">
              <img
                :src="scope.row.headimgurl ? scope.row.headimgurl : ''"
                :onerror="scope.row.gender === 1 ? moveErrorMan : moveErrorWomen"
                class="head_url"
                alt="">
            </template>
          </el-table-column>
          <el-table-column
            v-for="column in columns"
            v-if="!column.show"
            :key="column.prop"
            :prop="column.prop"
            :label="column.label"
            :width="column.width"
            :formatter="column.formatter"
          />
          <!--          <el-table-column-->
          <!--            label="课程制作权限"-->
          <!--          >-->
          <!--            <template slot-scope="scope">-->
          <!--              <span v-if="scope.row.is_course_make === 1">{{ scope.row.is_course_make_text }}</span>-->
          <!--              <span v-else>{{ scope.row.is_course_make_text }}</span>-->
          <!--              <el-switch-->
          <!--                :value="scope.row.is_course_make === 1"-->
          <!--                active-color="#13ce66"-->
          <!--                inactive-color="#e3e3e3"-->
          <!--                @change="switchCourseMake(scope.row)"/>-->
          <!--            </template>-->
          <!--          </el-table-column>-->
          <el-table-column
            v-if="$permissions('school_teacher_list_status')"
            label="是否禁用">
            <template slot-scope="scope">
              <span v-if="scope.row.status === 1">{{ scope.row.status_text }}</span>
              <span v-else>{{ scope.row.status_text }}</span>
              <el-switch
                :value="scope.row.status === 1"
                active-color="#13ce66"
                inactive-color="#e3e3e3"
                @change="switchStatus(scope.row)"/>
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            width="250px"
            class="orgin-btn">
            <template slot-scope="scope">
              <template v-if="$store.state.from === 'schoolCenter'">
                <el-link
                  v-if="$permissions('school_teacher_list_edit')"
                  size="small"
                  @click="edit(scope.row)"
                >编辑</el-link>
                <i class="icon-splite">|</i>
                <el-link
                  v-if="$permissions('school_teacher_list_statistics')"
                  size="small"
                  @click="Statistics(scope.row.id, scope.row.name)"
                >上课统计</el-link>
              </template>
              <template v-else>
                <el-button
                  v-if="$permissions('school_teacher_list_edit')"
                  size="small"
                  @click="edit(scope.row)"
                >编辑</el-button>
                <el-button
                  v-if="$permissions('school_teacher_list_statistics')"
                  size="small"
                  @click="Statistics(scope.row.id, scope.row.name)"
                >上课统计</el-button>
                <!--              <el-button-->
                <!--                size="small"-->
                <!--                type="danger"-->
                <!--                plain-->
                <!--                @click="del(scope.row.id)"-->
                <!--              >删除</el-button>-->
                <!--              <el-dropdown trigger="hover">-->
                <!--              <span class="el-dropdown-link">-->
                <!--                更多<i class="el-icon-caret-bottom el-icon&#45;&#45;right"/>-->
                <!--              </span>-->
                <!--                <el-dropdown-menu slot="dropdown">-->
                <!--&lt;!&ndash;                  <el-dropdown-item&ndash;&gt;-->
                <!--&lt;!&ndash;                    class="clearfix">&ndash;&gt;-->
                <!--&lt;!&ndash;                  <span&ndash;&gt;-->
                <!--&lt;!&ndash;                    class="dropdownSpan"&ndash;&gt;-->
                <!--&lt;!&ndash;                    @click="authCourseware(scope.row.id)">授权课件</span>&ndash;&gt;-->
                <!--&lt;!&ndash;                  </el-dropdown-item>&ndash;&gt;-->
                <!--                  <el-dropdown-item-->
                <!--                    class="clearfix">-->
                <!--                  <span-->
                <!--                    class="dropdownSpan"-->
                <!--                    @click="Statistics(scope.row.id, scope.row.name)">上课统计</span>-->
                <!--                  </el-dropdown-item>-->
                <!--&lt;!&ndash;                  <el-dropdown-item&ndash;&gt;-->
                <!--&lt;!&ndash;                    class="clearfix">&ndash;&gt;-->
                <!--&lt;!&ndash;                  <span&ndash;&gt;-->
                <!--&lt;!&ndash;                    class="dropdownSpan"&ndash;&gt;-->
                <!--&lt;!&ndash;                    @click="checkDevice(scope.row.id)">设备检测</span>&ndash;&gt;-->
                <!--&lt;!&ndash;                  </el-dropdown-item>&ndash;&gt;-->
                <!--                  <el-dropdown-item-->
                <!--                    class="clearfix">-->
                <!--                  <span-->
                <!--                    class="dropdownSpan"-->
                <!--                    @click="resetPassword(scope.row.id)">重置密码</span>-->
                <!--                  </el-dropdown-item>-->
                <!--                </el-dropdown-menu>-->
                <!--              </el-dropdown>-->
              </template>
            </template>
          </el-table-column>
        </el-table>
      </template>
    </AppList>
    <el-dialog
      :title="dialogTitle === 'add' ? '新增老师': '修改老师'"
      :visible.sync="formDialogVisible"
      width="1000px">
      <el-form
        ref="form"
        :rules="rules"
        :model="formData"
        label-width="125px">
        <el-row>
          <el-col :span="12">
            <el-form-item
              label="真实姓名："
              prop="name">
              <el-input
                v-model="formData.name"
                placeholder="请输入真实姓名"/>
            </el-form-item>
            <el-form-item
              v-if="roleList"
              label="角色："
              prop="role_ids">
              <el-checkbox-group
                :disabled="dialogTitle"
                v-model="formData.role_ids">
                <el-checkbox
                  v-for="(item, index) in roleList"
                  v-if="item.id === 1"
                  :key="index"
                  :label="item.id">
                  {{ item.name }}
                </el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <!--            <el-form-item label="课程制作权限：" prop="is_course_make">-->
            <!--              <el-switch-->
            <!--                v-model="formData.is_course_make"-->
            <!--                :active-value="1"-->
            <!--                :inactive-value="2"-->
            <!--                active-color="#13ce66"-->
            <!--                inactive-color="#e3e3e3">-->
            <!--              </el-switch>-->
            <!--              <span>{{ formData.is_course_make === 1 ? '开启' : '关闭' }}</span>-->
            <!--            </el-form-item>-->
            <el-form-item
              label="联系电话："
              prop="mobile">
              <el-input
                v-model="formData.mobile"
                :disabled="dialogTitle!=='add'"
                placeholder="请输入联系电话"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="真实头像："
              class="headimgurl">
              <AppUploadScale
                v-model="formData.headimgurl"
                class="form_img"
                @on-success="getThumbnailrUrl" />
            </el-form-item>
            <el-form-item
              label="性别："
              prop="gender">
              <el-radio
                v-model="formData.gender"
                :label="1">男</el-radio>
              <el-radio
                v-model="formData.gender"
                :label="2">女</el-radio>
            </el-form-item>
            <el-form-item label="邮箱：">
              <el-input
                v-model="formData.email"
                placeholder="请输入邮箱"/>
            </el-form-item>
          </el-col>
        </el-row>
        <div class="tips">
          <div class="left">温馨提醒：</div>
          <div class="right">
            <p>老师使用手机号登录后台和直播端。</p>
            <p>初始密码：a123456</p>
            <p>初始密码较为简单，老师需登录后台修改密码哦！</p>
          </div>
        </div>
      </el-form>
      <span
        slot="footer"
        class="dialog-footer">
        <el-button @click="formDialogVisible = false">取 消</el-button>
        <el-button
          type="primary"
          @click="submitStaff">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import list from '@/mixins/list';
import baseUrl from '../../utils/api';
import defaultMan from '@/assets/images/staff_man.png';
import defaultWomen from '@/assets/images/staff_women.png';

export default {
  name: 'Staff',
  inject: ['reload'],
  mixins: [list],
  data() {
    return {
      apiUrl: '',
      list: {},
      formDialogVisible: false,
      moveErrorMan: `this.src="${defaultMan}"`,
      moveErrorWomen: `this.src="${defaultWomen}"`,
      form: {
        name: '', // 姓名
        role_ids: [1], // 角色id
        role_text: [], // 角色名称
        is_course_make: 2, // 制作权限 //1=开启；2=不开启
        mobile: '', // 电话
        headimgurl: '', // 头像
        gender: 1, // 性别
        email: '', // 邮箱
      },
      formData: {},
      rules: {
        name: [
          { required: true, message: '请输入姓名', trigger: 'blur' },
        ],
        role_ids: [
          { required: true, message: '请选择角色' },
        ],
        is_course_make: [
          { required: true, message: '请选择课程制作权限' },
        ],
        mobile: [
          this.$rules.required('手机号'), { ...this.$rules.mobile },
        ],
        gender: [
          { required: true, message: '请选择性别' },
        ],
      },
      dialogTitle: '',
      isCreated: true,
      roleList: [],
    };
  },
  computed: {
    columns() {
      return [
        { prop: 'name', label: '老师名称' },
        { prop: 'wechat_name', label: '微信昵称' },
        {
          label: '性别',
          width: '80px',
          formatter: row => (row.gender === 1 ? '男' : '女'),
        },
        { prop: 'mobile', label: '联系电话' },
        { prop: 'email', label: '邮箱', width: '200px' },
        // { prop: 'name2', label: '上课次数' },
        { prop: 'created_at', label: '注册时间', width: '160px' },
      ];
    },
    searchArr() {
      const column = [
        { prop: 'name', label: '老师名称' },
        { prop: 'mobile', label: '联系电话' },
      ];
      return [
        { componentType: 'AppSearchColumn', searchType: column },
      ];
    },
    user() {
      return this.$store.state.user;
    },
  },
  watch: {
    roleList() {
      this.show = false;
      this.$nextTick(() => {
        this.show = true;
      });
    },
  },
  created() {
    this.formData = this.form;
    const arr = [2, 4, 5];
    const role = this.user.role_text.findIndex(item => arr.includes(item.role_id));
    if (role !== -1) {
      this.apiUrl = '/api/staff?equal[role_id]=1';
    } else {
      this.apiUrl = `/api/staff?equal[role_id]=1&&equal[id]=${this.user.id}`;
    }

    if (this.$store.state.roleList) {
      this.roleList = this.$store.state.roleList;
    } else {
      this.$http.get('/api/role').then((res) => {
        this.roleList = res.items;
        this.$store.state.roleList = res.items;
      });
    }
  },
  methods: {
    // 授权课件入口
    authCourseware(id) {
      this.$router.push(`/teacher/courseware/${id}`);
    },
    // 上课统计入口
    Statistics(id) {
      this.$router.push(`/teacher/statistics/${id}`);
    },
    // 新增老师按钮
    toCreate() {
      this.formDialogVisible = true;
      this.dialogTitle = 'add';
      this.formData = this.form;
    },
    // 编辑老师按钮
    edit(row) {
      this.formDialogVisible = true;
      this.formData = {
        ...row,
        role_ids: row.role_text.map(item => item.role_id),
      };
      this.dialogTitle = 'edit';
    },
    // 删除老师按钮
    del(id) {
      this.$confirm('是否删除老师?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.$http.delete(`/api/staff/${id}`)
          .then(() => {
            this.$message({
              type: 'success',
              message: '删除成功!',
            });
            this.reload();
          })
          .catch((err) => {
            this.$message.error(err.message);
          });
      });
    },
    // 修改课程权限
    switchCourseMake(row) {
      const is_course_make = {
        is_course_make: row.is_course_make === 1 ? 2 : 1,
      };
      this.$confirm('确定修改课程权限吗', '确认', {
        showCancelButton: true,
        type: 'success',
        confirmButtonText: '确定',
        confirmButtonClass: 'el-button--success',
      })
        .then(() => {
          this.$http
            .patch(`/api/staff/${row.id}/is_course_make`, is_course_make)
            .then((res) => {
              this.$message.success('状态修改成功');
              this.reload();
            })
            .catch((err) => {
              this.$message.error(err.message);
            });
        });
    },
    // 修改禁用状态
    switchStatus(row) {
      const status = {
        status: row.status === 1 ? 2 : 1,
      };
      this.$confirm('确定修改状态吗', '确认', {
        showCancelButton: true,
        type: 'success',
        confirmButtonText: '确定',
        confirmButtonClass: 'el-button--success',
      })
        .then(() => {
          this.$http
            .patch(`/api/staff/${row.id}/status`, status)
            .then((res) => {
              this.$message.success('状态修改成功');
              this.reload();
            })
            .catch((err) => {
              this.$message.error(err.message);
            });
        });
    },
    // 重置密码
    resetPassword(id) {
      this.$confirm('是否要重置密码?', '提示', {
        confirmButtonText: '重置',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.$http
          .patch(`${baseUrl}/api/users/${this.user.uuid}/password/init`)
          .then((res) => {
            this.$alert('初始密码：a123456', '重置成功！');
            this.reload();
          })
          .catch((err) => {
            this.$message.error(err.message);
          });
      });
    },
    // 上传图片
    getThumbnailrUrl(url) {
      this.$nextTick(() => {
        this.formData.headimgurl = url;
      });
      this.$forceUpdate();
    },
    // 设备检测
    checkDevice() {

    },
    // 批量导入
    excelExport() {

    },
    // 下载模板
    downloadTemplate() {

    },
    // 提交新增员工
    submitStaff() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.isCreated) {
            if (this.dialogTitle === 'add') {
              // 新增
              this.isCreated = false;
              this.$http.post('/api/staff', this.formData)
                .then(() => {
                  this.isCreated = true;
                  this.$message.success('保存成功');
                  this.formDialogVisible = false;
                  this.reload();
                })
                .catch((err) => {
                  this.isCreated = true;
                  this.$message.error(err.message);
                });
            } else {
              // 修改
              this.isCreated = false;
              this.$http.put(`/api/staff/${this.formData.id}`, this.formData)
                .then(() => {
                  this.isCreated = true;
                  this.$message.success('保存成功');
                  this.formDialogVisible = false;
                  this.reload();
                })
                .catch((err) => {
                  this.isCreated = true;
                  this.$message.error(err.message);
                });
            }
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
.staff {
  .form_img {
    width: 100px;
    height: 100px;
  }
  .tips{
    display: flex;
    font-size: 12px;
    color: red;
    .left {
      flex: 0 0 125px;
      text-align: right;
      line-height: 20px;
    }
    .right {
      p {
        margin: 0;
        line-height: 20px;
      }
    }
  }
  .headimgurl {
    margin-bottom: 9px;
  }
  .el-checkbox-group {
    display: inline-block;
    .el-checkbox {
      margin-right: 5px;
    }
  }
  .el-icon-question {
    display: inline-block;
    vertical-align: middle;
    cursor: pointer;
    font-size: 18px;
    color: var(--color-primary);
  }
  .head_url {
    width: 40px;
    height: 40px;
    border-radius: 50%;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Teacher/index.vue